import { getOperation } from "../../api"
import { get } from "svelte/store"
import { _ } from "svelte-i18n"
import { newNotification } from "../../store"
export function opStemFromSame(op: Operation | OperationOut, cartOp: Operation) {
    // Nur ein Angebot (OperationOut) trägt refNumber und verweist damit auf
    // seinen Eingangs-Vorgang. Ein Auftrag wird direkt über die id verglichen.
    if ("refNumber" in op && !!op.refNumber) {
        return (
            cartOp.operationOutOfferReference?.number == op.number &&
            cartOp.positions[0].operationOutOfferReference.number == op.number
        )
    } else {
        return (
            op.id == cartOp.id && !cartOp.positions[0].operationOutOfferReference && !cartOp.operationOutOfferReference
        )
    }
}
// cypres trigg
export function checkWheterOperationIsInCart(op: Operation | OperationOut, carts: Cart[]) {
    let opInCart: boolean[] = []
    if (!carts) return false
    carts.forEach((cart) => {
        cart.operations.forEach((cartOp) => {
            if (opStemFromSame(op, cartOp)) {
                opInCart.push(true)
            } else {
                opInCart.push(false)
            }
        })
    })
    return opInCart.includes(true)
}

export async function getOriginOffer(op: OperationOut): Promise<Operation> {
    const response = await getOperation(
        "operation",
        {
            number: op.refNumber,
            type: 1,
        },
        null,
        null,
        "full"
    )
    const originOffer: Operation = response?.data?.[0] as Operation
    if (!originOffer) {
        newNotification({ class: "error", html: get(_)("cart.referenceOfferNotFound") })
        return null
    }
    originOffer.positions.forEach((p, i) => {
        if (!op.positions[i]) return
        originOffer.positions[i].orderQuantity = op.positions[i].orderQuantity
    })
    originOffer.operationOutOfferReference = {
        id: op.id,
        number: op.number,
    }
    originOffer.positions.forEach((p, i) => {
        if (!op.positions[i]) return
        originOffer.positions[i].operationOutOfferReference = {
            id: op.id,
            number: op.number,
            positionNumber: op.positions[i].number,
        }
    })
    return originOffer
}
